import React from 'react';
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifButton,
  MotifIcon,
  MotifFormField,
  MotifCheckbox,
} from '@ey-xd/motif-react';
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import {
  Gcsp_Opps_Details_Modal_State,
  Gcsp_Opps_Details_Warning_Modal_State,
} from '../../../recoil/recoil';
import '../../organisms/modals/styles/plOpportunityNameModalStyles.css';
import { alertIcWarning24px } from '@ey-xd/motif-react/assets/icons';
import {
  MessageHeading,
  MessageParagraph,
  ModalHeaderContainer,
} from './styles/plOpportunityNameModal.styles';
import { IFRAME_EXIT_MODAL_REFRESH, warningMessages } from '../../../constants/commonConstants';

function GcspOpportunityNameModal(props) {
  let targetUrl = props.urlSource;

  // Use States
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [checkedCheckbox, setCheckbox] = useState(false);

  // Recoil States
  const [showGcspIframeModalRecoil, setGcspIframeModalRecoil] = useRecoilState(
    Gcsp_Opps_Details_Modal_State,
  ); // This state is used to manipulate iframe modal from another component

  const [showGcspInnerWarningModalRecoil, setGcspInnerWarningModalRecoil] = useRecoilState(
    Gcsp_Opps_Details_Warning_Modal_State,
  ); // This state is used to do not open modal if do not show again is clicked

  const onGcspCloseModal = () => {
    if (showGcspInnerWarningModalRecoil) {
      setGcspIframeModalRecoil(false);
    } else {
      setShowWarningModal(true); // Close warnig modal
    }
  };

  const onToggleCheckbox = toggleValue => {
    setCheckbox(toggleValue);
    setGcspInnerWarningModalRecoil(toggleValue);
  };

  const onWarningCloseModal = () => {
    setShowWarningModal(false);
  };

  const onGoBackClick = () => {
    setShowWarningModal(false);
    // Comment below two lines, if checkbox should be keep selected for go back option
    setCheckbox(false);
    setGcspInnerWarningModalRecoil(false);
  };

  const onExitOppsDetailsClick = () => {
    setGcspIframeModalRecoil(false);
    setShowWarningModal(false);
    clearTimeout();

    setTimeout(() => {
      window.location.reload(); // To refresh the Page
    }, 0);
  };

  return (
    <>
      {/* iFrame Modal */}
      <MotifModal
        show={showGcspIframeModalRecoil}
        onClose={() => onGcspCloseModal()}
        variant="default"
        size="xl"
        className="pl-opps-modal-container"
        // takeover= 'true'
      >
        <MotifModalHeader title="Close opportunity details modal">
          {IFRAME_EXIT_MODAL_REFRESH.TITLE}
        </MotifModalHeader>
        <MotifModalBody className="modal-body">
          <iframe src={targetUrl} className="iframe-container"></iframe>
        </MotifModalBody>
      </MotifModal>

      {/* Warning Close Modal */}
      {showWarningModal && (
        <MotifModal
          show={showGcspIframeModalRecoil}
          onClose={() => onWarningCloseModal()}
          variant="alt"
          size="md"
        >
          <MotifModalHeader title="Close opportunity details modal">
            <ModalHeaderContainer>
              <MotifIcon className="modal-header-icon" src={alertIcWarning24px} />
              {IFRAME_EXIT_MODAL_REFRESH.DESCRIPTION1}
            </ModalHeaderContainer>
          </MotifModalHeader>
          <MotifModalBody className="modal-body warning-modal-body">
            <MessageParagraph>{IFRAME_EXIT_MODAL_REFRESH.DESCRIPTION2}</MessageParagraph>

            <MessageHeading>{IFRAME_EXIT_MODAL_REFRESH.GO_BACK}</MessageHeading>
            <MessageParagraph>{IFRAME_EXIT_MODAL_REFRESH.DESCRIPTION3}</MessageParagraph>

            <MessageHeading>{IFRAME_EXIT_MODAL_REFRESH.EXIT_REFRESH}</MessageHeading>
            <MessageParagraph>{IFRAME_EXIT_MODAL_REFRESH.DESCRIPTION4}</MessageParagraph>

            {/* Commented as per new requirement */}
            {/* <MotifFormField className="do-not-show-checkbox">
              <MotifCheckbox
                id="pl-warning-close-modal"
                value="do-not-show-again"
                name="do-not-show-again"
                checked={checkedCheckbox}
                onChange={(event) => onToggleCheckbox(event.target.checked)}
              >
                {warningMessages.do_not_show_again}
              </MotifCheckbox>
            </MotifFormField> */}
          </MotifModalBody>

          <MotifModalFooter>
            <MotifButton variant="warn" type="button" onClick={onGoBackClick}>
              {IFRAME_EXIT_MODAL_REFRESH.GO_BACK}
            </MotifButton>
            <MotifButton variant="secondary" type="button" onClick={onExitOppsDetailsClick}>
              {IFRAME_EXIT_MODAL_REFRESH.EXIT_REFRESH}
            </MotifButton>
          </MotifModalFooter>
        </MotifModal>
      )}
    </>
  );
}

export default GcspOpportunityNameModal;
